var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.26892C0 3.2393 0.360371 2.38988 1.08108 1.72066C1.80179 1.05141 2.73875 0.716797 3.89189 0.716797C5.02446 0.716797 5.94079 1.04625 6.64093 1.70521C7.36164 2.38475 7.72201 3.27019 7.72201 4.36158C7.72201 5.35 7.37195 6.17366 6.67181 6.83263C5.9511 7.51216 5.00386 7.85193 3.83012 7.85193H3.79923C2.66666 7.85193 1.75033 7.51216 1.05019 6.83263C0.350054 6.15309 0 5.29851 0 4.26892ZM0.401544 31.2959V10.6627H7.25869V31.2959H0.401544ZM11.0579 31.2959H17.9151V19.7747C17.9151 19.054 17.9974 18.498 18.1622 18.1068C18.4504 17.4066 18.888 16.8146 19.4749 16.3307C20.0618 15.8468 20.7979 15.6048 21.6834 15.6048C23.9897 15.6048 25.1429 17.1595 25.1429 20.2689V31.2959H32V19.4658C32 16.4182 31.2793 14.1068 29.8378 12.5315C28.3964 10.9562 26.4916 10.1685 24.1236 10.1685C21.4672 10.1685 19.3977 11.3114 17.9151 13.5971V13.6589H17.8842L17.9151 13.5971V10.6627H11.0579C11.0991 11.3217 11.1197 13.3706 11.1197 16.8095C11.1197 20.2483 11.0991 25.0771 11.0579 31.2959Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_4739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentcolor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic-linkedin.47a5c90cc24f4fe9cf1e569fc2573538.svg";
export { ForwardRef as ReactComponent };